import { render, staticRenderFns } from "./BaoCaoTinhHinhTaiChinhCaNam.vue?vue&type=template&id=936563cc&scoped=true"
import script from "./BaoCaoTinhHinhTaiChinhCaNam.vue?vue&type=script&lang=js"
export * from "./BaoCaoTinhHinhTaiChinhCaNam.vue?vue&type=script&lang=js"
import style0 from "./BaoCaoTinhHinhTaiChinhCaNam.vue?vue&type=style&index=0&id=936563cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936563cc",
  null
  
)

export default component.exports